import axios from "axios";
import {
    IP
} from "../index";

/* 血压测量仪支付记录 */

// 查询
export async function selectApi() {
    var resp = await axios.post(`${IP}/admin/instrumentOrder/select`, {

    });
    return resp.data;
}
// 删除
export async function deleteApi(id) {
    var resp = await axios.post(`${IP}/admin/instrumentOrder/delete`, {
        id
    });
    return resp.data;
}